import { Component, Input } from '@angular/core';
@Component({
  selector: 'bn-transactions-filter',
  templateUrl: 'bn-transaction-filter.component.html',
  styles: [
  ]
})
export class BnTransactionsFilterComponent{
  @Input() hostRef: any;
}
